import { emptyMarket } from "../../constants";
import { fillEmptyMarketSelections } from "../fillEmptyMarketSelections";
export const prepareEmptyMarket = (eventId, template, index) => {
    const emptyLocalMarket = Object.assign({}, emptyMarket);
    emptyLocalMarket.id = `${eventId}-empty-${index}`;
    emptyLocalMarket.selections = fillEmptyMarketSelections(template);
    emptyLocalMarket.template = template;
    return emptyLocalMarket;
};
//# sourceMappingURL=prepareEmptyMarket.js.map